export const CITY_GUIDE = 'City Guide';
export const CITY_GUIDE_TYPE_ACTIVITIES = 'Activities';
export const CITY_GUIDE_VIEW = 'city_guide_view';
export const CITY_GUIDE_CREATE = 'city_guide_create';
export const CITY_GUIDE_EDIT = 'city_guide_edit';
export const CITY_GUIDE_IMAGE_TYPE = 'city_guide';
export const CITY_GUIDE_TYPE_CATEGORY = 'CATEGORY';
export const CITY_GUIDE_CATEGORY_VIEW = 'category_view';
export const CITY_GUIDE_CATEGORY_CREATE = 'category_create';
export const CITY_GUIDE_CATEGORY_EDIT = 'category_edit';

export const CITY_GUIDE_ADD_ACTIVITY_TAB = [
  'Details',
  'Duration',
  'Location',
  'Information',
  'Media',
];
export const UNITS = ['Kilometers', 'Meters', 'Miles'];

export const VALID_DATE_TIME_ERROR_MESSAGE =
  "'Valid from' date should take place before the 'Valid till date'";
export const VALID_TIME_ERROR_MESSAGE =
  "'Valid from' time should take place before the 'Valid till time'";

export const CITYGUIDE_INFO_TYPES = [
  {
    text: 'Email',
    value: 'EMAIL',
    title: 'Add Email Title',
    valueType: 'Email',
  },
  {
    text: 'URL',
    value: 'URL',
    title: 'Add URL Title',
    valueType: 'URL',
  },
  {
    text: 'Phone Number',
    value: 'PHONE',
    title: 'Add Phone Number Title',
    valueType: 'Phone',
  },
  {
    text: 'Social Media',
    value: 'SOCIAL_MEDIA',
    title: 'Social Media Title (Ex: Instagram / Facebook)',
    valueType: 'URL',
  },
];

export const CITY_GUIDE_FILTER_STATUS_SUBMENU = [
  { id: 'active', name: 'Active', selected: false },
  { id: 'inactive', name: 'Inactive', selected: false },
];
